import type { ReversePixelMapper } from "./ReversePixelMapper";
import { isReversePixelMapper } from "./ReversePixelMapper";

/**
 * Partial derivatives of reverse mapping function.
 */
export type PartialDerivatives = [number, number, number, number];

/**
 * ReversePixelMapper with support of Elliptical Weighted Average color resapmling.
 */
export interface EwaReversePixelMapper extends ReversePixelMapper {
  /**
   * Flags that pixel mapper has constant partial derivatives, so there is
   * no need to recalculate EWA ellipse for each point.
   */
  readonly isConstantPartialDerivatives: boolean;

  /**
   * Returns mapper partial derivatives for given point.
   *
   * @param x
   * @param y
   */
  getPartialDerivatives(x: number, y: number): PartialDerivatives;
}

/**
 * Checks if passed object implements EwaReversePixelMapper interface.
 *
 * @param obj
 */
export function isEwaReversePixelMapper(
  obj: unknown
): obj is EwaReversePixelMapper {
  type C = Partial<EwaReversePixelMapper>;
  return (
    isReversePixelMapper(obj) &&
    typeof (obj as C).getPartialDerivatives === "function" &&
    typeof (obj as C).isConstantPartialDerivatives === "boolean"
  );
}
